import GiftApp from './GiftApp';

export default GiftApp;
